import { OrdersInfo } from "@/data/client";
import { defineStore } from "pinia";

export const useOrdersStore = defineStore("orders", {
  state: () => ({
    orders: [] as OrdersInfo[],
    showAllOrders: false,
  }),
  actions: {
    setOrders(orders: OrdersInfo[]) {
      this.orders = orders;
    },
    emptyOrderStore() {
      this.orders = [];
    },
    setShowAllOrders(show: boolean) {
      this.showAllOrders = show;
    },
  },
});
